// extracted by mini-css-extract-plugin
export default {"container":"SearchResultsPage_container__dlmKN"};